module.exports = __webpack_public_path__ + "img/store-1.79fddca0.svg";